// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 4ESElDpoIut
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ControllerCard from "../../ControllerCard"; // plasmic-import: dV16dnG2PJ/component
import SelectControllerType from "../../SelectControllerType"; // plasmic-import: xDTa0-BXY5s/component
import SelectCountry from "../../SelectCountry"; // plasmic-import: DRLS9kjJ501/component
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import ContinueButton from "../../ContinueButton"; // plasmic-import: COGC0l6Auj/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingController.module.css"; // plasmic-import: 4ESElDpoIut/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingController__VariantProps = new Array();

export const PlasmicOnboardingController__ArgProps = new Array(
  "certificationText",
  "errorSlot"
);

const $$ = {};

function PlasmicOnboardingController__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "countrySelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectControllerType.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__jh8Rt)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hifl4
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__sKaGr)}>
            <div className={classNames(projectcss.all, sty.freeBox__gasrU)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__yTt94)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__rgvXt)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__xkug2)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__fx0To)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__jaeU4)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__vsAv3)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__h8K3I)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__qAms)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__toZs6)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fzI3O)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__bIYhb)}
            >
              <div
                data-plasmic-name={"setupDetailsText"}
                data-plasmic-override={overrides.setupDetailsText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.setupDetailsText
                )}
              >
                {"Setup Details"}
              </div>
              <div
                data-plasmic-name={"accountDetailsText"}
                data-plasmic-override={overrides.accountDetailsText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.accountDetailsText
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8FkxN
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__y8XvY
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__oR2XO
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__w2780)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__a83K
                )}
              >
                {"Controller and Beneficial Owners"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ypBuD
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {
                      "To comply with regulatory guidelines, we require that you provide information on the following individuals:\n"
                    }
                  </React.Fragment>
                  {
                    <ol
                      data-plasmic-name={"ol"}
                      data-plasmic-override={overrides.ol}
                      className={classNames(
                        projectcss.all,
                        projectcss.ol,
                        sty.ol
                      )}
                    >
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li___2Hf9Q
                        )}
                      >
                        {
                          "Manager - One person who is responsible for managing your company."
                        }
                      </li>
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li___9HkQm
                        )}
                      >
                        {
                          "Owners - Every person who owns at least 25% or more of your company.  "
                        }
                      </li>
                    </ol>
                  }

                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8ZmiJ
                )}
              >
                {"Please add each individual who meets the above criteria."}
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"controllerStack"}
                data-plasmic-override={overrides.controllerStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.controllerStack)}
              >
                <ControllerCard
                  data-plasmic-name={"controllerCard"}
                  data-plasmic-override={overrides.controllerCard}
                  className={classNames("__wab_instance", sty.controllerCard)}
                  controllerName={"Individual Name"}
                />
              </p.Stack>
              <p.Stack
                as={"div"}
                data-plasmic-name={"addNew"}
                data-plasmic-override={overrides.addNew}
                hasGap={true}
                className={classNames(projectcss.all, sty.addNew)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nv3QU
                  )}
                >
                  {"+"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lnJj8
                  )}
                >
                  {"Add New"}
                </div>
              </p.Stack>
              <div
                data-plasmic-name={"addControllerStack"}
                data-plasmic-override={overrides.addControllerStack}
                className={classNames(projectcss.all, sty.addControllerStack)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___2J1Z6)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mYuNr)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__xtUPk
                      )}
                    >
                      {"First Name"}
                    </div>
                    <input
                      data-plasmic-name={"firstName"}
                      data-plasmic-override={overrides.firstName}
                      className={classNames(
                        projectcss.all,
                        projectcss.input,
                        sty.firstName
                      )}
                      placeholder={"First"}
                      ref={ref => {
                        $refs["firstName"] = ref;
                      }}
                      size={1}
                      type={"text"}
                      value={""}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___33Dq8)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___0TVms
                      )}
                    >
                      {"Last Name"}
                    </div>
                    <input
                      data-plasmic-name={"lastName"}
                      data-plasmic-override={overrides.lastName}
                      className={classNames(
                        projectcss.all,
                        projectcss.input,
                        sty.lastName
                      )}
                      placeholder={"Last"}
                      ref={ref => {
                        $refs["lastName"] = ref;
                      }}
                      size={1}
                      type={"text"}
                      value={""}
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__oTJyP)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5Otb
                    )}
                  >
                    {"Individual Type"}
                  </div>
                  <SelectControllerType
                    data-plasmic-name={"selectControllerType"}
                    data-plasmic-override={overrides.selectControllerType}
                    className={classNames(
                      "__wab_instance",
                      sty.selectControllerType
                    )}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "selectControllerType",
                        "value"
                      ])(eventArgs[0]);
                    }}
                    value={p.generateStateValueProp($state, [
                      "selectControllerType",
                      "value"
                    ])}
                  />
                </div>
                <div
                  data-plasmic-name={"deleteStack"}
                  data-plasmic-override={overrides.deleteStack}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.deleteStack
                  )}
                >
                  {"X"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__xDHe2)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___93MPa
                    )}
                  >
                    {"Job Title"}
                  </div>
                  <input
                    data-plasmic-name={"jobTitle"}
                    data-plasmic-override={overrides.jobTitle}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.jobTitle
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["jobTitle"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__iiOvc)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__gsizn
                    )}
                  >
                    {"Phone Number"}
                  </div>
                  <input
                    data-plasmic-name={"phoneNumber"}
                    data-plasmic-override={overrides.phoneNumber}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.phoneNumber
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["phoneNumber"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox___3AsZ)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__wsAw7
                    )}
                  >
                    {"Email"}
                  </div>
                  <input
                    data-plasmic-name={"email"}
                    data-plasmic-override={overrides.email}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.email
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["email"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__tbBsT)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__h5JPf
                    )}
                  >
                    {"Address"}
                  </div>
                  <SelectCountry
                    data-plasmic-name={"countrySelect"}
                    data-plasmic-override={overrides.countrySelect}
                    className={classNames("__wab_instance", sty.countrySelect)}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "countrySelect",
                        "value"
                      ])(eventArgs[0]);
                    }}
                    placeholder={"Country"}
                    value={p.generateStateValueProp($state, [
                      "countrySelect",
                      "value"
                    ])}
                  />

                  <input
                    data-plasmic-name={"address1"}
                    data-plasmic-override={overrides.address1}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.address1
                    )}
                    placeholder={"Address Line 1"}
                    ref={ref => {
                      $refs["address1"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <input
                    data-plasmic-name={"city"}
                    data-plasmic-override={overrides.city}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.city
                    )}
                    placeholder={"City"}
                    ref={ref => {
                      $refs["city"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <SelectState
                    data-plasmic-name={"selectState"}
                    data-plasmic-override={overrides.selectState}
                    className={classNames("__wab_instance", sty.selectState)}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "selectState",
                        "value"
                      ])(eventArgs[0]);
                    }}
                    placeholder={"State"}
                    value={p.generateStateValueProp($state, [
                      "selectState",
                      "value"
                    ])}
                  />

                  <input
                    data-plasmic-name={"zip"}
                    data-plasmic-override={overrides.zip}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.zip
                    )}
                    placeholder={"ZIP"}
                    ref={ref => {
                      $refs["zip"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__ui6O)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pOiN9
                    )}
                  >
                    {"Ownership Percentage"}
                  </div>
                  <input
                    data-plasmic-name={"ownership"}
                    data-plasmic-override={overrides.ownership}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.ownership
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["ownership"] = ref;
                    }}
                    size={1}
                    type={"number"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__au4Lz)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__ihdcv
                    )}
                  >
                    {"Date of Birth"}
                  </div>
                  <div
                    data-plasmic-name={"dob"}
                    data-plasmic-override={overrides.dob}
                    className={classNames(projectcss.all, sty.dob)}
                  />
                </div>
                <div
                  data-plasmic-name={"ssnStack"}
                  data-plasmic-override={overrides.ssnStack}
                  className={classNames(projectcss.all, sty.ssnStack)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__tS1Zm
                    )}
                  >
                    {"Social Security Number"}
                  </div>
                  <input
                    data-plasmic-name={"ssn"}
                    data-plasmic-override={overrides.ssn}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.ssn
                    )}
                    placeholder={"XXX-XX-XXXX"}
                    ref={ref => {
                      $refs["ssn"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div
                  data-plasmic-name={"passportStack"}
                  data-plasmic-override={overrides.passportStack}
                  className={classNames(projectcss.all, sty.passportStack)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__bgkS9
                    )}
                  >
                    {"Passport Number"}
                  </div>
                  <input
                    data-plasmic-name={"passport"}
                    data-plasmic-override={overrides.passport}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.passport
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["passport"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div
                  data-plasmic-name={"controllerStackError"}
                  data-plasmic-override={overrides.controllerStackError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.controllerStackError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  data-plasmic-name={"ageError"}
                  data-plasmic-override={overrides.ageError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.ageError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Individual must be at least 18 years old to pass certification"
                        }
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Individual must be at least 18 years old to pass certification"
                        }
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  data-plasmic-name={"ssnError"}
                  data-plasmic-override={overrides.ssnError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.ssnError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Individual must be at least 18 years old to pass certification"
                        }
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Must provide all 9 digits of the social security number"
                        }
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  data-plasmic-name={"submitButton"}
                  data-plasmic-override={overrides.submitButton}
                  className={classNames(projectcss.all, sty.submitButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xsRqg
                    )}
                  >
                    {"Submit"}
                  </div>
                </div>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__x0LTk
                )}
              >
                {"Certification"}
              </div>
              <div
                data-plasmic-name={"certificationText"}
                data-plasmic-override={overrides.certificationText}
                className={classNames(projectcss.all, sty.certificationText)}
              >
                {p.renderPlasmicSlot({
                  defaultContents:
                    "I, Joe Doe, hereby certify, to the best of my knowledge, that the information provided above is complete and correct.",
                  value: args.certificationText,
                  className: classNames(sty.slotTargetCertificationText)
                })}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qj2J
                )}
              >
                {"Signer Name"}
              </div>
              <input
                data-plasmic-name={"signature"}
                data-plasmic-override={overrides.signature}
                className={classNames(
                  projectcss.all,
                  projectcss.input,
                  sty.signature
                )}
                placeholder={""}
                ref={ref => {
                  $refs["signature"] = ref;
                }}
                size={1}
                type={"text"}
                value={""}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yY73C
                )}
              >
                {"Date"}
              </div>
              <div
                data-plasmic-name={"currentDate"}
                data-plasmic-override={overrides.currentDate}
                className={classNames(projectcss.all, sty.currentDate)}
              />

              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(projectcss.all, sty.errorText)}
              >
                <div
                  data-plasmic-name={"errorSlot1"}
                  data-plasmic-override={overrides.errorSlot1}
                  className={classNames(projectcss.all, sty.errorSlot1)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__pKmZ
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ color: "#FF0000" }}
                          >
                            {"Must complete all required fields"}
                          </span>
                        </React.Fragment>
                      </div>
                    ),

                    value: args.errorSlot,
                    className: classNames(sty.slotTargetErrorSlot)
                  })}
                </div>
              </div>
              <ContinueButton
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames("__wab_instance", sty.continueButton)}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "setupDetailsText",
    "accountDetailsText",
    "ol",
    "controllerStack",
    "controllerCard",
    "addNew",
    "addControllerStack",
    "firstName",
    "lastName",
    "selectControllerType",
    "deleteStack",
    "jobTitle",
    "phoneNumber",
    "email",
    "countrySelect",
    "address1",
    "city",
    "selectState",
    "zip",
    "ownership",
    "dob",
    "ssnStack",
    "ssn",
    "passportStack",
    "passport",
    "controllerStackError",
    "ageError",
    "ssnError",
    "submitButton",
    "certificationText",
    "signature",
    "currentDate",
    "errorText",
    "errorSlot1",
    "continueButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  setupDetailsText: ["setupDetailsText"],
  accountDetailsText: ["accountDetailsText"],
  ol: ["ol"],
  controllerStack: ["controllerStack", "controllerCard"],
  controllerCard: ["controllerCard"],
  addNew: ["addNew"],
  addControllerStack: [
    "addControllerStack",
    "firstName",
    "lastName",
    "selectControllerType",
    "deleteStack",
    "jobTitle",
    "phoneNumber",
    "email",
    "countrySelect",
    "address1",
    "city",
    "selectState",
    "zip",
    "ownership",
    "dob",
    "ssnStack",
    "ssn",
    "passportStack",
    "passport",
    "controllerStackError",
    "ageError",
    "ssnError",
    "submitButton"
  ],

  firstName: ["firstName"],
  lastName: ["lastName"],
  selectControllerType: ["selectControllerType"],
  deleteStack: ["deleteStack"],
  jobTitle: ["jobTitle"],
  phoneNumber: ["phoneNumber"],
  email: ["email"],
  countrySelect: ["countrySelect"],
  address1: ["address1"],
  city: ["city"],
  selectState: ["selectState"],
  zip: ["zip"],
  ownership: ["ownership"],
  dob: ["dob"],
  ssnStack: ["ssnStack", "ssn"],
  ssn: ["ssn"],
  passportStack: ["passportStack", "passport"],
  passport: ["passport"],
  controllerStackError: ["controllerStackError"],
  ageError: ["ageError"],
  ssnError: ["ssnError"],
  submitButton: ["submitButton"],
  certificationText: ["certificationText"],
  signature: ["signature"],
  currentDate: ["currentDate"],
  errorText: ["errorText", "errorSlot1"],
  errorSlot1: ["errorSlot1"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingController__ArgProps,
          internalVariantPropNames: PlasmicOnboardingController__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingController__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingController";
  } else {
    func.displayName = `PlasmicOnboardingController.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingController = Object.assign(
  // Top-level PlasmicOnboardingController renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    setupDetailsText: makeNodeComponent("setupDetailsText"),
    accountDetailsText: makeNodeComponent("accountDetailsText"),
    ol: makeNodeComponent("ol"),
    controllerStack: makeNodeComponent("controllerStack"),
    controllerCard: makeNodeComponent("controllerCard"),
    addNew: makeNodeComponent("addNew"),
    addControllerStack: makeNodeComponent("addControllerStack"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    selectControllerType: makeNodeComponent("selectControllerType"),
    deleteStack: makeNodeComponent("deleteStack"),
    jobTitle: makeNodeComponent("jobTitle"),
    phoneNumber: makeNodeComponent("phoneNumber"),
    email: makeNodeComponent("email"),
    countrySelect: makeNodeComponent("countrySelect"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    selectState: makeNodeComponent("selectState"),
    zip: makeNodeComponent("zip"),
    ownership: makeNodeComponent("ownership"),
    dob: makeNodeComponent("dob"),
    ssnStack: makeNodeComponent("ssnStack"),
    ssn: makeNodeComponent("ssn"),
    passportStack: makeNodeComponent("passportStack"),
    passport: makeNodeComponent("passport"),
    controllerStackError: makeNodeComponent("controllerStackError"),
    ageError: makeNodeComponent("ageError"),
    ssnError: makeNodeComponent("ssnError"),
    submitButton: makeNodeComponent("submitButton"),
    certificationText: makeNodeComponent("certificationText"),
    signature: makeNodeComponent("signature"),
    currentDate: makeNodeComponent("currentDate"),
    errorText: makeNodeComponent("errorText"),
    errorSlot1: makeNodeComponent("errorSlot1"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingController
    internalVariantProps: PlasmicOnboardingController__VariantProps,
    internalArgProps: PlasmicOnboardingController__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingController;
/* prettier-ignore-end */
